export interface MicrosoftProtectedResource {
  url: string;
  scopes: string[];
}

export interface MicrosoftAuthConfig {
  clientId: string;
  authority: string;
  redirectUri: string;
  protectedResources: MicrosoftProtectedResource[];
  protectedResourcesDefaultScope: string[];
}
